import React from 'react'
import styled from '@emotion/styled'

const RegisterBarContainer = styled.div`
  .newsletter {
    width: 100%;
    background-image: url('/images/newsletter_background.jpg');
    padding: 20px;
  }
  .newsletter_background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .newsletter_container {
    width: 100%;
  }
  .newsletter_title {
    font-family: 'Roboto Slab', serif;
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
    color: #ffffff;
  }
  .newsletter_subtitle {
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    margin-top: 6px;
  }
  .newsletter_form_container {
    width: 450px;
    padding-left: 20px;
  }
  .newsletter_form {
    display: block;
    position: relative;
    width: 100%;
  }
  .newsletter_input {
    width: calc(100% - 136px);
    height: 40px;
    background: rgba(255, 255, 255, 0.4);
    border: none;
    outline: none;
    padding-left: 20px;
    color: #ffffff;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .newsletter_input::-webkit-input-placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffffff !important;
  }
  .newsletter_input:-moz-placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffffff !important;
  }
  .newsletter_input::-moz-placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffffff !important;
  }
  .newsletter_input:-ms-input-placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffffff !important;
  }
  .newsletter_input::input-placeholder {
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #ffffff !important;
  }
  .newsletter_button {
    width: 136px;
    height: 40px;
    background: #ffffff;
    border-radius: 3px;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 14px;
    text-transform: uppercase;
    color: ${props => props.theme.colors.primary};
    font-weight: 500;
    letter-spacing: 0.1em;
    box-shadow: 0px 5px 40px rgba(29, 34, 47, 0.15);
  }
  .newsletter_button:hover {
    box-shadow: 0px 5px 40px rgba(29, 34, 47, 0.45);
  }
`

const RegisterBar = ({ input }) => (
  <RegisterBarContainer>
    <div className="newsletter">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="newsletter_container d-flex flex-lg-row flex-column align-items-center justify-content-start">
              <div className="newsletter_content text-lg-left text-center">
                <div className="newsletter_title">{input.primary.register_bar_title.text}</div>
                <div className="newsletter_subtitle">
                  {input.primary.description1.text}
                </div>
              </div>

              <div className="newsletter_form_container ml-lg-auto">
                <form
                  action="#"
                  id="newsletter_form"
                  className="newsletter_form d-flex flex-row align-items-center justify-content-center"
                >
                  <button type="submit" className="newsletter_button">
                    {input.primary.button_label.text}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </RegisterBarContainer>
)

export default RegisterBar
